import { AssetProvider } from './asset';

export * from './cursor';
export * from './state';
export * from './canvas';
export * from './cache';
export * from './image';
export * from './text-layout';
export * from './dirty';

export { AssetProvider } from './asset';

export const requiredProviders = {
  asset: AssetProvider,
};

export type RendererProviders = typeof requiredProviders;
